// 底部导航栏
import VantTabbar from "@/components/VantTabbar/VantTabbar";

export default {
  install(Vue) {
    Vue.component("VantTabbar", VantTabbar);
  }
};



// WEBPACK FOOTER //
// ./src/components/index.js